import "./App.css";

import React from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import AboutUs from "./Components/AboutUs";
import Videos from "./Components/Videos";
import EventList from "./Components/Shows/EventList";
import TeamMembers from "./Components/Members/TeamMembers";
import BlogPost from "./Components/Members/BlogPost";
import MusicSection from "./Components/Music/MusicSection";
import SongList from "./Components/SongList";
import Contact from "./Components/Contact";
import References from "./Components/References";
import Gallery from "./Components/Gallery";

const App = () => {
  return (
    <div className="App">
      <Header />
      <AboutUs />
      <TeamMembers />
      {/* <BlogPost /> */}
      <MusicSection />
      <SongList />
      <Videos />
      <EventList />
      <Gallery />
      <References />
      <Contact />
      <Footer />
    </div>
  );
};

export default App;
